import type { SaasLeadRepository } from '@zetyar/data-contracts'
import { createSupabaseSaasLeadRepository } from '@zetyar/supabase-client'
import { getSupabaseClient } from '@/infrastructure/supabase/app'

export const webSaasLeadRepository: SaasLeadRepository = createSupabaseSaasLeadRepository(getSupabaseClient())
